/**
 * Free-gift engine: keeps the $0 "Free Gift" line in sync with the cart.
 * Rule: subtotal (excluding the gift itself) >= $60 -> gift present,
 * below -> gift removed. Runs on page load and after every cart update
 * the theme dispatches. Guarded so its own cart writes don't loop.
 */
(function () {
  var GIFT_VARIANT = 49923029664001;
  var THRESHOLD_CENTS = 6000;
  var busy = false;

  function reconcile() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var giftLine = null;
        var subtotal = 0;
        cart.items.forEach(function (item, i) {
          if (item.variant_id === GIFT_VARIANT) {
            giftLine = { index: i + 1, quantity: item.quantity };
          } else {
            subtotal += item.final_line_price;
          }
        });

        if (subtotal >= THRESHOLD_CENTS && !giftLine) {
          return mutate('/cart/add.js', { items: [{ id: GIFT_VARIANT, quantity: 1 }] });
        }
        if (giftLine && (subtotal < THRESHOLD_CENTS || giftLine.quantity > 1)) {
          var qty = subtotal >= THRESHOLD_CENTS ? 1 : 0;
          return mutate('/cart/change.js', { line: giftLine.index, quantity: qty });
        }
      })
      .catch(function () { /* transient; next cart event retries */ })
      .then(function (changed) {
        busy = false;
        if (changed) refreshUi();
      });
  }

  function mutate(url, payload) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).then(function () { return true; });
  }

  function refreshUi() {
    // Let the theme repaint from a fresh cart, then hard-fallback if the
    // drawer/cart page is visible so the gift line is never stale.
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'gift-engine', data: { source: 'gift-engine', itemCount: cart.item_count } },
        }));
        var cartVisible = document.querySelector('cart-drawer-component[open], dialog[open] .cart-totals')
          || location.pathname === '/cart';
        if (cartVisible) window.location.reload();
      });
  }

  document.addEventListener('cart:update', function (e) {
    var src = e.detail && (e.detail.sourceId || (e.detail.data && e.detail.data.source));
    if (src === 'gift-engine') return;
    reconcile();
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcile);
  } else {
    reconcile();
  }
})();
